import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="components--search-bar"
export default class extends Controller {
  static targets = [
    "input"
  ]

  static values = {
    result: String,
    timeout: Number
  }

  static classes = [
    "loading"
  ]

  connect() {
    this.searchResultTarget = document.getElementById(this.resultValue)

    this.element.addEventListener("turbo:submit-start", (_) => { this.submitStart() })
    this.element.addEventListener("turbo:submit-end", (_) => { this.submitEnd() })
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", (_) => { this.submitStart() })
    this.element.removeEventListener("turbo:submit-end", (_) => { this.submitEnd() })
  }

  submitStart() {
    this.searchResultTarget.classList.add(...this.loadingClasses)
  }

  submitEnd() {
    this.searchResultTarget.classList.remove(...this.loadingClasses)

    this.searchResultTarget.scrollTo(0, { behavior: "smooth" })
  }

  search() {
    clearTimeout(this.currentTimeout)

    this.currentTimeout = setTimeout(() => { this.element.requestSubmit() }, this.timeoutValue)
  }
}